import Vue from "vue";
/**
 * 全局按钮操作权限指令
 * */
export const allow = {
  inserted: function (el, binding) {
    const permission = binding.value;
    if (permission) {
      if (!judge(permission)) {
        // 没有权限 移除Dom元素
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  }
};

// 判断是否有权限
function judge(value) {
  let isHas;
  if (Array.isArray(value[1])) {
    for (let i = 0; i < value[1].length; i++) {
      isHas = value[0].includes(value[1][i]);
      if (isHas) {
        break;
      }
    }
  } else {
    if (value[0]) {
      isHas = value[0].includes(value[1]);
    } else {
      isHas = false;
    }
  }
  // 开发添加所有权限
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'tests') {
    return true;
  }
  return isHas;
}


// 滚动加载更多
export const loadMore = {
  inserted(el, binding) {
    const callback = binding.value; // 获取指令绑定的回调函数  
    const options = binding.arg || {}; // 获取指令的参数（可选）  

    let isLoading = false; // 加载状态，防止重复加载  
    el.addEventListener('scroll', () => {
      // 判断是否滚动到底部  
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - (options.offset || 10)) {
        if (!isLoading) {
          isLoading = true; // 设置加载状态  
          callback(() => {
            isLoading = false; // 加载完成后重置状态  
          });
        }
      }
    });
  },
}


// el-table 表格自适应高度滚动--作用于父级元素
function setTableHeight(el, binding) {
  const { value } = binding;
  const customHeight = (value && value.height) || 40;
  const height = window.innerHeight - el.getBoundingClientRect().top - customHeight;
  el.style.height = `${height}px`;
}

export const tableHeight = {
  bind(el, binding) {
    el.resizeListener = () => {
      setTableHeight(el, binding);
    };
    window.document.body.addEventListener('resize', el.resizeListener);
  },
  update(el, binding) {
    setTableHeight(el, binding);
  },
  unbind(el) {
    window.document.body.removeEventListener('resize', el.resizeListener);
  }
};

// 滚动设置透明度
export const fadeOnScroll = {
  inserted(el, binding) {
    // 默认配置
    const defaultOptions = {
      minScroll: 100,     // 透明度为1的最小滚动距离
      maxScroll: 800,     // 透明度为0的最大滚动距离
      scrollElement: window, // 默认滚动元素是window
      immediate: true     // 是否立即执行一次
    };

    // 合并配置
    const options = {
      ...defaultOptions,
      ...binding.value
    };

    // 处理滚动元素参数
    let actualScrollElement = window;
    if (options.scrollElement && options.scrollElement !== window) {
      if (typeof options.scrollElement === 'string') {
        const element = document.querySelector(options.scrollElement);
        if (element) {
          actualScrollElement = element;
        } else {
          console.warn(`[v-fade-on-scroll] 找不到元素: ${options.scrollElement}，将使用window`);
        }
      } else if (options.scrollElement instanceof Element) {
        actualScrollElement = options.scrollElement;
      }
    }

    // 计算透明度的函数
    const calculateOpacity = (scrollTop) => {
      if (scrollTop <= options.minScroll) {
        return 1;
      } else if (scrollTop >= options.maxScroll) {
        return 0;
      } else {
        // 线性计算透明度
        return (options.maxScroll - scrollTop) / (options.maxScroll - options.minScroll);
      }
    };

    // 更新透明度的函数
    const updateOpacity = () => {
      let scrollTop;

      if (actualScrollElement === window) {
        scrollTop = window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      } else {
        scrollTop = actualScrollElement.scrollTop;
      }

      const opacity = calculateOpacity(scrollTop);
      el.style.opacity = opacity;
      el.style.transition = 'opacity 0.1s ease';
      if (opacity > 0) {
        el.style.visibility = 'visible';
      } else {
        el.style.visibility = 'hidden';
      }

      // 可选：触发自定义事件
      const event = new CustomEvent('fade-on-scroll-update', {
        detail: { scrollTop, opacity, element: el }
      });
      el.dispatchEvent(event);
    };

    // 防抖函数（性能优化）
    const createDebounce = (func, wait) => {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
      };
    };

    // 创建防抖版本的更新函数
    const debouncedUpdate = createDebounce(updateOpacity, 10);

    // 存储相关数据到元素上
    el._fadeOnScroll = {
      handler: debouncedUpdate,
      options: {
        minScroll: options.minScroll,
        maxScroll: options.maxScroll,
        immediate: options.immediate,
        scrollElementSelector: typeof options.scrollElement === 'string' ? options.scrollElement : null
      },
      actualScrollElement: actualScrollElement
    };

    // 添加滚动监听
    actualScrollElement.addEventListener('scroll', debouncedUpdate);

    // 如果需要，立即执行一次
    if (options.immediate) {
      requestAnimationFrame(() => {
        updateOpacity();
      });
    }
  },

  update(el, binding) {
    // 获取存储的数据
    const storedData = el._fadeOnScroll;
    if (!storedData) return;

    // 获取新的配置
    const newOptions = {
      minScroll: 100,
      maxScroll: 800,
      scrollElement: window,
      immediate: true,
      ...binding.value
    };

    // 检查配置是否发生变化（避免循环引用）
    const optionsChanged =
      storedData.options.minScroll !== newOptions.minScroll ||
      storedData.options.maxScroll !== newOptions.maxScroll ||
      storedData.options.immediate !== newOptions.immediate ||
      storedData.options.scrollElementSelector !== (typeof newOptions.scrollElement === 'string' ? newOptions.scrollElement : null);

    // 检查滚动元素是否发生变化
    let scrollElementChanged = false;
    if (typeof newOptions.scrollElement === 'string') {
      scrollElementChanged = storedData.options.scrollElementSelector !== newOptions.scrollElement;
    } else if (newOptions.scrollElement instanceof Element) {
      scrollElementChanged = storedData.actualScrollElement !== newOptions.scrollElement;
    } else {
      scrollElementChanged = storedData.actualScrollElement !== window;
    }

    // 如果配置有变化，重新绑定
    if (optionsChanged || scrollElementChanged) {
      // 先解绑旧的监听
      storedData.actualScrollElement.removeEventListener('scroll', storedData.handler);

      // 重新绑定
      this.bind(el, binding);
    }
  },

  unbind(el) {
    const storedData = el._fadeOnScroll;
    if (storedData) {
      // 移除滚动监听
      storedData.actualScrollElement.removeEventListener('scroll', storedData.handler);

      // 清理存储的数据
      delete el._fadeOnScroll;
    }
  }
}